import React, { useContext, useEffect, useRef } from 'react'
import withJWTSession from 'src/enhancers/jwt_session'

import Navigation from './navigation'
import NavBar from './navbar'
import Breadcrumb from './breadcrumb'

import useWindowSize from 'src/components/hooks/use_window_size'
import useOutsideClick from 'src/components/hooks/use_outside_click'
import ThemeContext from 'src/components/system_wide/theme_context'
import * as actionType from 'src/lib/actions'

const Layout = ({ children }) => {
  const windowSize = useWindowSize()
  const ref = useRef()
  const configContext = useContext(ThemeContext)

  const { collapseMenu, headerFixedLayout } = configContext.state
  const { dispatch } = configContext

  useEffect(() => {
    if (windowSize.width > 992 && windowSize.width <= 1024) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }

    if (windowSize.width < 992) {
      dispatch({ type: actionType.CHANGE_LAYOUT, layout: 'vertical' })
    }
  }, [dispatch, windowSize.width])

  useOutsideClick(ref, () => {
    if (collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }
  })

  const mobileOutClickHandler = () => {
    if (windowSize.width < 992 && collapseMenu) {
      dispatch({ type: actionType.COLLAPSE_MENU })
    }
  }

  let mainClass = ['pcoded-wrapper', 'd-flex', 'flex-fill']

  let common = (
    <>
      <Navigation />
      <NavBar />
    </>
  )

  let mainContainer = (
    <>
      <div
        className="d-flex flex-column flex-fill pcoded-main-container"
        style={{ minHeight: 'auto', marginRight: '0px' }}>
        <div className={mainClass.join(' ')}>
          <div className="pcoded-content d-flex flex-fill pt-2 pb-0">
            <div className="pcoded-inner-content d-flex flex-fill flex-column">
              <Breadcrumb />
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )

  if (windowSize.width < 992) {
    let outSideClass = ['nav-outside']
    if (collapseMenu) outSideClass.push('mob-backdrop')
    if (headerFixedLayout) outSideClass.push('mob-fixed')

    common = (
      <div className={outSideClass.join(' ')} ref={ref}>
        {common}
      </div>
    )

    mainContainer = (
      <div
        role="button"
        tabIndex="0"
        className="pcoded-outside d-flex flex-column flex-fill"
        onClick={mobileOutClickHandler}
        onKeyDown={mobileOutClickHandler}>
        {mainContainer}
      </div>
    )
  }

  return (
    <>
      {common}
      {mainContainer}
    </>
  )
}

export default withJWTSession({ invalid: '/login' })(Layout)
